import { react2angular } from 'react2angular';
import TermsAndConditionsModal from './index';

export const TermsAndConditionsModule = angular
  .module('app.components.TermsAndConditionsModal.termsAndConditionsModal', [])
  .component('termsAndConditionsModal', react2angular(TermsAndConditionsModal))
  .name;


// WEBPACK FOOTER //
// ./src/app/admin/components/TermsAndConditionsModal/index.ng.js